// Screen `recorder-settings` (owner: meeting-recorder, owner feedback F15). Settings › Tasks & activities ›
// Meeting notes; the settings layout shows a "turned off" state while the `recorder` module is off.
import { createFileRoute } from '@tanstack/react-router';
import { RecorderSettingsPage } from '../../../features/recorder/RecorderSettingsPage';

export const Route = createFileRoute('/_settings/settings/recorder')({ component: RecorderSettingsPage });
